import { userInfo } from '@apollo-internal/cache';
import { useReactiveVar } from '@apollo/client';
import { VIP_PORTAL_ADMIN } from '../../../../../constants/system-roles';
import SUPPLEMENTAL_ROLE from '../../../../../constants/supplemental-Roles';
import { PAGE_MODE } from '../constants';
import { ROLES_MAP } from '@shared/constants/roles-map';
import { UserTiers } from '../../../../../constants/userTiers';

const useCalendarPageMode = (isUserActingAsATM, appraiserEvent) => {
  const currentUserInfo = useReactiveVar(userInfo);

  return getPageMode(
    currentUserInfo.SystemRole.Id,
    currentUserInfo.SupplementalRole?.Id,
    isUserActingAsATM,
    appraiserEvent
  );
};

const getPageMode = (systemRoleId, supplementalRoleId, isUserActingAsATM, appraiserEvent) => {
  if (systemRoleId === VIP_PORTAL_ADMIN && !isUserActingAsATM) {
    return PAGE_MODE.VIP_ADMIN;
  }

  if (appraiserEvent === null) {
    return PAGE_MODE.TBD;
  }

  if (isUserActingAsATM) {
    return PAGE_MODE.ATM;
  }

  if (ROLES_MAP[UserTiers.Org].includes(systemRoleId)) {
    return supplementalRoleId === SUPPLEMENTAL_ROLE.ATM ? PAGE_MODE.ORG_ATM : PAGE_MODE.ORG;
  }

  if (ROLES_MAP[UserTiers.OrgUnit].includes(systemRoleId)) {
    return supplementalRoleId === SUPPLEMENTAL_ROLE.ATM
      ? PAGE_MODE.ORG_UNIT_ATM
      : PAGE_MODE.ORG_UNIT;
  }

  if (supplementalRoleId === SUPPLEMENTAL_ROLE.ATM) {
    return PAGE_MODE.ATM;
  }

  if (supplementalRoleId === SUPPLEMENTAL_ROLE.ATL) {
    const participationInfo = appraiserEvent?.TargetUserEventParticipationInfo;
    if (participationInfo?.IsUserAtlObserver) {
      return PAGE_MODE.ATL_OBSERVER;
    }

    if (participationInfo?.IsUserInvitedAtlObserver) {
      return PAGE_MODE.ASSIGNED_ATL_OBSERVER;
    }

    return PAGE_MODE.ISACA_APPRAISER_ATL;
  }

  throw new Error('Unsupported mode');
};

export default useCalendarPageMode;
